import styles from './M30ProductFeaturesCard.module.scss';
import classNames from 'classnames';
import { Paragraph, Picture } from 'ui/components';
import { Icon } from 'ui/components/1-atoms/Media/Icon';
import IconPlay from 'ui/icons/icon_play.svg';

export interface M30ProductFeaturesCardProps {
	className?: string;
	image?: {
		url: string;
		altText?: string;
		focalPoint?: { left: number; top: number };
		extension?: string;
	};
	text?: string;
	youtubeLink?: string;
	title?: string;
}

export const M30ProductFeaturesCard: React.FC<M30ProductFeaturesCardProps> = ({ className, image, text, youtubeLink, title }) => {
	return (
		<section className={classNames(styles.M30ProductFeaturesCard, className)}>
			<div className={styles.M30ProductFeaturesCard_link}>
				<div className={styles.M30ProductFeaturesCard_image}>
					<div className={styles.M30ProductFeaturesCard_imageBox}>
						<Picture url={image?.url} aspectRatio={0.75} className={styles.M30ProductFeaturesCard_imageElement} />

						{youtubeLink && (
							<Icon className={classNames(styles.M30ProductFeaturesCard_videoIcon)} size="lg">
								<IconPlay />
							</Icon>
						)}
					</div>
				</div>

				<div className={styles.M30ProductFeaturesCard_details}>
					<Paragraph className={styles.M30ProductFeaturesCard_name}>{title}</Paragraph>
					<Paragraph className={styles.M30ProductFeaturesCard_Description}>{text}</Paragraph>
				</div>
			</div>
		</section>
	);
};
